<app-nexleader-vimeo-video
  *ngIf="vimeoId"
  [vimeoId]="vimeoId"
  [vimeoDownloadId]="vimeoDownloadId"
  [hideDownloadLink]="hideDownloadLink"
></app-nexleader-vimeo-video>
